import React from 'react';
import PropTypes from 'prop-types';

import { useCombobox } from './ComboboxContext';

const ComboboxEmpty = ({ children }) => {
  const { isOpen, hasFilteredResults } = useCombobox();

  if (!isOpen || hasFilteredResults) return null;

  return (
    <div className="combobox__empty" role="status">
      {children}
    </div>
  );
};

ComboboxEmpty.propTypes = {
  children: PropTypes.node,
};

export default ComboboxEmpty;
